import React from "react";

const RefreshLoader = () => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center">
        <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Refreshing session, please wait...</p>
      </div>
    </div>
  );
};

export default RefreshLoader;
